// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSettingOutlinedSvg from "@fishx/icons-svg/es/asn/PSettingOutlined";
import FishxIcon from '../components/FishxIcon';

var PSettingOutlined = function PSettingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSettingOutlinedSvg
  }));
};

PSettingOutlined.displayName = 'PSettingOutlined';
export default React.forwardRef(PSettingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSettingOutlined.js
// module id = 3619
// module chunks = 0